<div class="phonebook-container">
  <div class="phonebook-header">
    <div class="header-left">
      <mat-icon>phone</mat-icon>
      <h3>{{ "PHONEBOOK" | translate }}</h3>
    </div>
    <button mat-icon-button class="close-button" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="phonebook-content">
    @if (loading) {
      <div class="empty-message" data-testid="phonebook-loading">
        <span class="fa-light fa-fw fa-spinner fa-spin"></span>
        {{ "LOADING" | translate }}
      </div>
    } @else if ((grouped | keyvalue).length === 0) {
      <div class="empty-message">
        <mat-icon>info</mat-icon>
        {{ "PHONEBOOK_EMPTY" | translate }}
      </div>
    }
    @for (group of grouped | keyvalue; track group) {
      <div>
        <div class="area-header">
          {{ group.key }}
        </div>
        @for (item of group.value; track item) {
          <div class="phone-row">
            <a [href]="'tel:' + item.phoneNumber">
              {{ item.phoneNumber }}
            </a>
          </div>
        }
      </div>
    }
  </div>
</div>